import Bugsnag from "@bugsnag/js";
import React from "react";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React);

export default ErrorBoundary;
